@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded) {
    <div class="configuration">
      <app-clm-product-line-header [isOem]="isOem()" [line]="entityLine()" (quantityChanged)="quantityChanged()"
        (tagInformationUpdated)="updateTaggingDetails($event)" [tags]="taggingDetails()">
      </app-clm-product-line-header>
      <app-clm-res-unit-information (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-clm-res-unit-information>
      <app-clm-res-options [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [imagePrefix]="imagePrefix"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-clm-res-options>
      <app-clm-res-accessories [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-clm-res-accessories>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>
